/* CART DRAWER (22.09.2026) — ported from the prototype (js/cart-drawer.js),
   WHOOP layout per Martina's reference. Real difference from the prototype:
   the prototype had no backend, so it simulated cart state in localStorage.
   This talks to Shopify's actual Ajax Cart API (/cart.js, /cart/add.js,
   /cart/change.js), so it's the real cart — same one checkout reads from,
   same one Shopify's own cart icon/count would reflect if this theme had
   one. A cart line's identity is Shopify's own `key` (variant id + any line
   item properties, e.g. engraving text) — that's already exactly the
   composite id+variant key the prototype's lineKey() used, just provided
   by the server instead of invented client-side.

   Buy now: adds the item via the same Ajax endpoint, then navigates to
   /checkout directly on success — the reliable, provider-agnostic way to
   do this (doesn't depend on Shop Pay/PayPal/Apple Pay being configured
   in Settings → Payments, unlike Shopify's dynamic checkout button).

   Panel mounts into <body>, same reason as the prototype and as
   mobile-nav.js: .navshell/.navbar have backdrop-filter/transform, which
   creates a containing block for `position: fixed` descendants.

   30.09.2026: "Akceptuję Regulamin sklepu" checkbox above "Przejdź do kasy".
   The checkout link is blocked (click handler below) until it is ticked —
   same behaviour and copy as sections/main-cart.liquid. Client-side only. */
(function () {
  let currentCart = null;

  function money(cents) {
    return (cents / 100).toLocaleString("pl-PL", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " zł";
  }

  function mountDrawer() {
    if (document.getElementById("cartDrawer")) return;
    const wrap = document.createElement("div");
    wrap.innerHTML = `
      <div class="cartdrawer" id="cartDrawer" hidden>
        <style>
          .cartdrawer__terms { margin-bottom: 0.25rem; }
          .cartdrawer__terms-label { display: flex; align-items: flex-start; gap: 0.6rem; font-family: var(--font-body); font-size: 0.875rem; line-height: 1.45; color: var(--color-navy-dark); cursor: pointer; }
          .cartdrawer__terms-input { flex: none; width: 1.1rem; height: 1.1rem; margin: 0.15rem 0 0; accent-color: #009fe3; cursor: pointer; }
          .cartdrawer__terms-label a { color: #009fe3; text-decoration: underline; }
          .cartdrawer__terms-error { margin: 0.5rem 0 0; font-family: var(--font-body); font-size: 0.8125rem; color: #b3261e; }
          .cartdrawer__terms-error[hidden] { display: none; }
          .cartdrawer__terms.is-invalid .cartdrawer__terms-input { outline: 2px solid #b3261e; outline-offset: 2px; }
        </style>
        <div class="cartdrawer__backdrop" data-cart-close></div>
        <aside class="cartdrawer__panel" role="dialog" aria-modal="true" aria-label="Koszyk">
          <div class="cartdrawer__head">
            <h2 class="cartdrawer__title">Twój koszyk</h2>
            <button class="cartdrawer__close" type="button" data-cart-close aria-label="Zamknij koszyk">
              <svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true"><path d="M1 1l14 14M15 1L1 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
            </button>
          </div>

          <div class="cartdrawer__shipping">
            <svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true"><path d="M2 5h9v7H2z M11 8h4l3 3v1h-7z" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/><circle cx="6" cy="14.5" r="1.5" fill="currentColor"/><circle cx="15" cy="14.5" r="1.5" fill="currentColor"/></svg>
            <span>Darmowa wysyłka wliczona w cenę</span>
          </div>

          <p class="cartdrawer__error" id="cartError" hidden></p>

          <div class="cartdrawer__body">
            <ul class="cartdrawer__items" id="cartItems"></ul>
            <p class="cartdrawer__empty" id="cartEmpty" hidden>Twój koszyk jest pusty.</p>
          </div>

          <div class="cartdrawer__summary" id="cartSummary">
            <div class="cartdrawer__row">
              <span>Suma częściowa</span>
              <span id="cartSubtotal">0,00 zł</span>
            </div>
            <div class="cartdrawer__row">
              <span>Dostawa</span>
              <span>Gratis</span>
            </div>
            <div class="cartdrawer__row cartdrawer__row--total">
              <span>Razem</span>
              <span id="cartTotal">0,00 zł</span>
            </div>
          </div>

          <div class="cartdrawer__actions">
            <div class="cartdrawer__terms" data-drawer-terms>
              <label class="cartdrawer__terms-label">
                <input type="checkbox" class="cartdrawer__terms-input" data-drawer-terms-checkbox aria-describedby="cartDrawerTermsError">
                <span>Akceptuję <a href="/pages/regulamin-sklepu" target="_blank" rel="noopener">Regulamin sklepu</a></span>
              </label>
              <p class="cartdrawer__terms-error" id="cartDrawerTermsError" role="alert" hidden>Zaznacz akceptację regulaminu, aby przejść do kasy.</p>
            </div>
            <a class="btn btn--solid" id="cartCheckout" href="/checkout">Przejdź do kasy</a>
            <button class="btn btn--outline" type="button" data-cart-close>Kontynuuj zakupy</button>
          </div>
        </aside>
      </div>`;
    document.body.appendChild(wrap.firstElementChild);
  }

  function itemRow(item) {
    const li = document.createElement("li");
    li.className = "cartitem";
    li.dataset.cartRow = item.key;
    const variantLabel = item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";
    li.innerHTML = `
      <img class="cartitem__img" src="${item.image || ""}" alt="" loading="lazy" />
      <div class="cartitem__body">
        <p class="cartitem__title">${item.product_title}</p>
        ${variantLabel ? `<p class="cartitem__variant">${variantLabel}</p>` : ""}
        <div class="cartitem__qty">
          <button type="button" data-qty-dec aria-label="Zmniejsz ilość">−</button>
          <span class="cartitem__qty-value">${item.quantity}</span>
          <button type="button" data-qty-inc aria-label="Zwiększ ilość">+</button>
        </div>
      </div>
      <div class="cartitem__side">
        <button class="cartitem__remove" type="button" data-cart-remove aria-label="Usuń ${item.product_title} z koszyka">
          <svg viewBox="0 0 16 16" width="15" height="15" aria-hidden="true"><path d="M2 4h12M6 4V2.5h4V4M3.5 4l.6 9.5a1 1 0 0 0 1 .9h5.8a1 1 0 0 0 1-.9L12.5 4" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
        <p class="cartitem__price">${money(item.final_line_price)}</p>
      </div>`;
    return li;
  }

  function render(cart) {
    currentCart = cart;
    const list = document.getElementById("cartItems");
    const empty = document.getElementById("cartEmpty");
    const summary = document.getElementById("cartSummary");
    const actions = document.querySelector(".cartdrawer__actions");
    if (!list) return;

    list.innerHTML = "";
    if (cart.item_count === 0) {
      empty.hidden = false;
      summary.hidden = true;
      actions.hidden = true;
    } else {
      empty.hidden = true;
      summary.hidden = false;
      actions.hidden = false;
      cart.items.forEach((item) => list.appendChild(itemRow(item)));
    }

    document.getElementById("cartSubtotal").textContent = money(cart.total_price);
    document.getElementById("cartTotal").textContent = money(cart.total_price);

    document.querySelectorAll("[data-cart-count]").forEach((el) => {
      el.textContent = String(cart.item_count);
      el.hidden = cart.item_count === 0;
    });
  }

  async function fetchCart() {
    const res = await fetch("/cart.js");
    return res.json();
  }

  function showError(message) {
    const el = document.getElementById("cartError");
    if (!el) return;
    if (!message) {
      el.hidden = true;
      el.textContent = "";
      return;
    }
    el.hidden = false;
    el.textContent = message;
  }

  async function addItem(variantId, quantity) {
    showError(null);
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] }),
      });
      if (!res.ok) {
        const err = await res.json();
        showError(err.description || "Nie udało się dodać produktu do koszyka.");
        return false;
      }
      render(await fetchCart());
      return true;
    } catch {
      showError("Błąd połączenia. Spróbuj ponownie.");
      return false;
    }
  }

  async function changeQty(key, quantity) {
    showError(null);
    try {
      const res = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity }),
      });
      if (!res.ok) {
        const err = await res.json();
        showError(err.description || "Nie udało się zaktualizować koszyka.");
        return;
      }
      render(await res.json());
    } catch {
      showError("Błąd połączenia. Spróbuj ponownie.");
    }
  }

  function open() {
    const drawer = document.getElementById("cartDrawer");
    drawer.hidden = false;
    requestAnimationFrame(() => drawer.classList.add("is-open"));
    document.body.classList.add("cartdrawer-open");
  }

  function close() {
    const drawer = document.getElementById("cartDrawer");
    drawer.classList.remove("is-open");
    document.body.classList.remove("cartdrawer-open");
    setTimeout(() => { drawer.hidden = true; }, 320);
  }

  function setTermsInvalid(invalid) {
    const wrap = document.querySelector("[data-drawer-terms]");
    if (!wrap) return;
    wrap.classList.toggle("is-invalid", invalid);
    wrap.querySelector(".cartdrawer__terms-error").hidden = !invalid;
  }

  mountDrawer();
  fetchCart().then(render);

  // Record the tick on the cart: Shopify copies cart attributes to the order (Additional details).
  // Ticking stores a UTC timestamp, unticking clears it. Client-side record, not a tamper-proof one.
  function recordTerms(checked) {
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ attributes: { "Regulamin zaakceptowany": checked ? new Date().toISOString() : "", "Regulamin zaakceptowany (źródło)": checked ? "Shopify – koszyk (tick-box)" : "" } }),
    }).catch(() => {});
  }

  document.addEventListener("change", (e) => {
    if (!e.target.matches("[data-drawer-terms-checkbox]")) return;
    if (e.target.checked) setTermsInvalid(false);
    recordTerms(e.target.checked);
  });

  document.addEventListener("click", (e) => {
    const checkoutLink = e.target.closest("#cartCheckout");
    if (checkoutLink) {
      const box = document.querySelector("[data-drawer-terms-checkbox]");
      if (box && !box.checked) {
        e.preventDefault();
        setTermsInvalid(true);
        box.focus();
      }
      return;
    }

    const addBtn = e.target.closest("[data-cart-add]");
    if (addBtn) {
      e.preventDefault();
      addBtn.disabled = true;
      addItem(addBtn.dataset.variantId, addBtn.dataset.cartQuantity || 1).finally(() => {
        addBtn.disabled = false;
      });
      open();
      return;
    }

    const buyBtn = e.target.closest("[data-buy-now]");
    if (buyBtn) {
      e.preventDefault();
      buyBtn.disabled = true;
      addItem(buyBtn.dataset.variantId, buyBtn.dataset.cartQuantity || 1).then((ok) => {
        if (ok) window.location.assign("/checkout");
        else buyBtn.disabled = false;
      });
      return;
    }

    const bundleBtn = e.target.closest("[data-cart-add-bundle]");
    if (bundleBtn) {
      e.preventDefault();
      try {
        const ids = JSON.parse(bundleBtn.dataset.variantIds || "[]");
        (async () => {
          for (const id of ids) {
            // eslint-disable-next-line no-await-in-loop
            await addItem(id, 1);
          }
        })();
      } catch (err) {
        console.error("[cart] nieprawidłowy JSON w data-variant-ids:", err);
      }
      open();
      return;
    }

    const toggle = e.target.closest("[data-cart-toggle]");
    if (toggle) {
      e.preventDefault();
      open();
      return;
    }

    if (e.target.closest("[data-cart-close]")) {
      close();
      return;
    }

    const inc = e.target.closest("[data-qty-inc]");
    if (inc) {
      const key = inc.closest("[data-cart-row]").dataset.cartRow;
      const item = currentCart.items.find((i) => i.key === key);
      if (item) changeQty(key, item.quantity + 1);
      return;
    }

    const dec = e.target.closest("[data-qty-dec]");
    if (dec) {
      const key = dec.closest("[data-cart-row]").dataset.cartRow;
      const item = currentCart.items.find((i) => i.key === key);
      if (item) changeQty(key, item.quantity - 1);
      return;
    }

    const remove = e.target.closest("[data-cart-remove]");
    if (remove) {
      changeQty(remove.closest("[data-cart-row]").dataset.cartRow, 0);
      return;
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && document.body.classList.contains("cartdrawer-open")) close();
  });
})();
